import React, { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styles from './PhoneNumberInput.module.scss'; // Importando o CSS para estilização
import { isValidPhoneNumber } from 'react-phone-number-input';

interface PhoneNumberInputProps {
  id: string;
  defaultValue?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: string | undefined) => void; // Callback opcional para mudanças
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({ id, defaultValue, className, required, disabled, onChange }) => {
  const [value, setValue] = useState<string | undefined>(undefined);
  const [isValid, setIsValid] = useState<boolean | undefined>(undefined); // Para verificar se o telefone é válido

  const handleChange = (phoneNumber: string | undefined) => {
    setValue(phoneNumber);

    if (phoneNumber) {
      const valid = isValidPhoneNumber(phoneNumber);
      setIsValid(valid);
    } else {
      setIsValid(undefined);
    }
    if (onChange) {
      onChange(phoneNumber);
    }
  };

  return (
    <div>
      <PhoneInput
        id={id}
        name={id}
        placeholder="Digite o telefone"
        value={defaultValue ?? value}
        onChange={handleChange}
        defaultCountry={defaultValue ? undefined : "BR"}
        international={true}
        required={required}
        disabled={disabled}
        className={['form-control', isValid === false ? 'is-invalid' : '', styles['phone-field'], className ?? ''].join(' ')}
      />
      {isValid === false && (
        <div className="invalid-feedback">
          Número de telefone inválido. Por favor, insira um número válido.
        </div>
      )}
    </div>
  );
};

export default PhoneNumberInput;
